<template>
  <div>
    <FeedbackListCard :search="search" :feedbacks="{}" />
  </div>
</template>
<script>
import FeedbackListCard from "../components/FeedbackListCard";
export default {
  components: {
    FeedbackListCard,
  },
  data() {
    return {
      dialog: false,
      scores: [
        { value: "Tümü", key: -1 },
        { value: 1, key: 1 },
        { value: 2, key: 2 },
        { value: 3, key: 3 },
        { value: 4, key: 4 },
        { value: 5, key: 5 },
      ],
      currentPage: 1,
      search: "",
    };
  },
};
</script>
